module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Profil ro.ca132916.svg";